const AUSTRIAN_REGION_IN_PHRASES: Readonly<Record<string, string>> = {
  Burgenland: 'im Burgenland',
  Steiermark: 'in der Steiermark',
};

const formatRegionInSearchTitle = (locationTitle: string): string | null => {
  if (locationTitle === 'Burgenland' || locationTitle.startsWith('Burgenland ')) {
    return locationTitle.replace(/^Burgenland/, 'im Burgenland');
  }

  if (locationTitle === 'Steiermark' || locationTitle.startsWith('Steiermark ')) {
    return locationTitle.replace(/^Steiermark/, 'in der Steiermark');
  }

  return null;
};

export const formatInAustrianRegion = (regionLabel: string): string =>
  AUSTRIAN_REGION_IN_PHRASES[regionLabel] ?? `in ${regionLabel}`;

export const formatSearchResultLocationPhrase = (
  locationTitle: string,
  inTranslation: string,
  locale = 'de',
): string => {
  const trimmed = locationTitle.trim();
  if (!trimmed) return '';

  if (locale === 'de') {
    const specialPhrase = formatRegionInSearchTitle(trimmed);
    if (specialPhrase) return specialPhrase;
  }

  return `${inTranslation} ${trimmed}`;
};
